import { utils } from '@digital-commerce/shared-utils'

const { isBusinessCart } = utils.cart

export const getCheckoutUrl = (cart, queryParams = '', lang = 'en') => {
  const businessSuffix = isBusinessCart(cart) ? 'business/' : ''
  return `/${lang}/${businessSuffix}commerce/checkout${queryParams}`
}
